export var TerraNetwork;
(function (TerraNetwork) {
    TerraNetwork["Bombay"] = "bombay-12";
    TerraNetwork["Columbus"] = "columbus-5";
})(TerraNetwork || (TerraNetwork = {}));
export const UNSUPPORTED_TERRA_NETWORK = `Terra is not supported by the current RenVM network.`;
export const transactionToDeposit = (transaction) => ({
    transaction,
    amount: transaction.amount,
});
//# sourceMappingURL=deposit.js.map